import React from 'react';
import ReactPaginate from 'react-paginate';
import {FaChevronRight, FaChevronLeft} from 'react-icons/fa';

export default function Pagination({
  page,
  pageCount,
  onPageChange,
}: {
  page: number;
  pageCount: number;
  onPageChange: (selectedItem: {selected: number}) => void;
}) {
  return (
    <ReactPaginate
      previousLabel={<FaChevronLeft size="1.3rem" />}
      nextLabel={<FaChevronRight size="1.3rem" />}
      onPageChange={onPageChange}
      forcePage={page}
      pageRangeDisplayed={3}
      marginPagesDisplayed={2}
      pageCount={pageCount}
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item"
      previousLinkClassName="page-link"
      nextClassName="page-item"
      nextLinkClassName="page-link"
      breakLabel="..."
      breakClassName="page-item"
      breakLinkClassName="page-link"
      containerClassName="pagination"
      activeClassName="active"
      renderOnZeroPageCount={null}
    />
  );
}
